export const ADD_SUCCESS = 'Новая роль добавлена';
export const ADD_ERROR = 'Не удалось добавить новую роль';
